export default __webpack_public_path__ + "static/media/waterfade.941cc666.png";